/*
  Leather grade rules for adding a product to the cart.

  Leather Grade is a real variant option and sets the price, but the chosen
  leather colour only travels to the cart as a text line-item property. Nothing
  in Shopify ties the two together, so the storefront must refuse a line whose
  leather belongs to a more expensive grade than the variant being bought.

  Only Grades 1 and 2 are sold online. Grade 3 and above are "Call For Pricing",
  except through Buy As Shown, which adds its own fixed grade and leather.

  Pure functions only: no DOM access, so the rules can be unit-tested.
*/
(function (root) {
  var HIGHEST_ONLINE_GRADE = 2;

  // "Grade 3" or 3 -> 3. Anything without a grade number ("No Grade", blank) -> null.
  function parseGrade(value) {
    if (typeof value === 'number') {
      return isFinite(value) && value > 0 ? Math.floor(value) : null;
    }
    if (typeof value !== 'string') {
      return null;
    }
    var match = value.match(/\bgrade\s*(\d+)/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function allow(reason) {
    return { allowed: true, reason: reason };
  }

  function block(reason) {
    return { allowed: false, reason: reason };
  }

  /*
    leatherGrade  grade of the leather that will be sent as the line property
    variantGrade  Leather Grade option value of the variant being added
    isBuyAsShown  true only when the Buy As Shown button is adding its configuration
  */
  function canAddToCart(options) {
    options = options || {};
    if (options.isBuyAsShown) {
      return allow('buy-as-shown');
    }

    var variantGrade = parseGrade(options.variantGrade);
    if (variantGrade === null) {
      return allow('no-leather-grade-option');
    }
    if (variantGrade > HIGHEST_ONLINE_GRADE) {
      return block('variant-call-for-pricing');
    }

    var leatherGrade = parseGrade(options.leatherGrade);
    if (leatherGrade === null) {
      return allow('no-leather-grade');
    }
    if (leatherGrade > HIGHEST_ONLINE_GRADE) {
      return block('leather-call-for-pricing');
    }
    if (leatherGrade > variantGrade) {
      return block('leather-above-variant');
    }
    return allow('grades-match');
  }

  var api = { parseGrade: parseGrade, canAddToCart: canAddToCart };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.LeatherGradeGuard = api;
  }
})(typeof window !== 'undefined' ? window : this);
